<template>
  <ul class="frisbuy-rating-bar">
    <li
      v-for="rating in props.divisionByRating"
      :key="rating.label"
      class="frisbuy-rating-bar__rate"
    >
      <label class="frisbuy-rating-bar__rate-label"> {{ rating.label }} </label>
      <span class="frisbuy-rating-bar__rate-icon">
        <StarRounded v-if="!props.isSoftStarIcon" />
        <StarSoftRounded v-else />
      </span>
      <div class="frisbuy-rating-bar__rate-progress-bar">
        <span
          class="frisbuy-rate-progress-bar__progress"
          :style="{ width: `${(rating.count / generalRating) * 100}%` }"
        ></span>
      </div>
      <span class="frisbuy-rating-bar__rate-count"> {{ rating.count }} </span>
    </li>
  </ul>
</template>

<style scoped lang="scss">
.frisbuy-rating-bar {
  &,
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  display: flex;
  flex-direction: column;
  list-style: none;

  gap: 10px 0;

  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #606266;

  &,
  .frisbuy-rating-bar__rate {
    margin: 0;
    padding: 0;
  }

  .frisbuy-rating-bar__rate {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;

    gap: 0 5px;

    .frisbuy-rating-bar__rate-label {
      width: 11px;

      font-weight: 700;
    }

    .frisbuy-rating-bar__rate-icon {
      display: flex;
    }

    .frisbuy-rating-bar__rate-progress-bar {
      position: relative;

      width: 278px;
      height: 6px;
      border-radius: 6px;

      background-color: #ebeef5;

      .frisbuy-rate-progress-bar__progress {
        display: block;

        width: 0;
        height: 100%;
        background-color: #606266;

        border-radius: inherit;
      }
    }

    .frisbuy-rating-bar__rate-count {
      font-size: 0.88rem;
    }
  }
}
</style>

<script setup lang="ts">
import StarRounded from "../../Icons/StarRounded.vue";
import StarSoftRounded from "../../Icons/StarSoftRounded.vue";

export type TRating = {
  label: string;
  count: number;
};

const props = defineProps<{
  divisionByRating: Array<TRating>;
  isSoftStarIcon?: boolean;
}>();

const generalRating: number = props.divisionByRating.reduce(
  (accumulator, currentValue) => {
    return accumulator + currentValue.count;
  },
  0
);
</script>
